module.exports = __webpack_public_path__ + "static/media/close.744fdf6d.svg";